import {sitesReducer} from "./sites/sites.reducers";
import {spacesReducer} from "./spaces/spaces.reducers";
import {profileReducer} from "./profile/profile.reducers";
import {dataSourceDimensionsReducer} from './dataSourceDimensions/dataSourceDimensions.reducers';
import {dataSourcesMetricsReducer} from "./dataSourcesMetrics/dataSourcesMetrics.reducers";
import {channelsReducer} from "./channels/channels.reducers";
import {dataSourcesAllReducer} from "./dataSourcesAll/dataSourcesAll.reducers";
import {usersReducer} from "./users/users.reducers";
import {SITES_STATE_NAME, SitesState} from "./sites/sites";
import {SitesEffects} from "./sites/sites.effects";
import {SpacesEffects} from "./spaces/spaces.effects";
import {ProfileEffects} from "./profile/profile.effects";
import {DataSourceDimensionsEffects} from "./dataSourceDimensions/dataSourceDimensions.effects";
import {DataSourcesMetricsEffects} from "./dataSourcesMetrics/dataSourcesMetrics.effects";
import {ChannelsEffects} from "./channels/channels.effects";
import {DataSourcesAllEffects} from "./dataSourcesAll/dataSourcesAll.effects";
import {UsersEffects} from "./users/users.effects";
import {SPACES_STATE_NAME, SpacesState} from "./spaces/spaces";
import {PROFILE_STATE_NAME, ProfileState} from "./profile/profile";
import {
  DATA_SOURCE_DIMENSIONS_STATE_NAME,
  DataSourceDimensionsState
} from './dataSourceDimensions/dataSourceDimensions';
import {DATA_SOURCES_METRICS_STATE_NAME, DataSourcesMetricsState} from "./dataSourcesMetrics/dataSourcesMetrics";
import {CHANNELS_STATE_NAME, ChannelsState} from "./channels/channels";
import {DATA_SOURCES_ALL_STATE_NAME, DataSourcesAllState} from "./dataSourcesAll/dataSourcesAll";
import {USERS_STATE_NAME, UsersState} from "./users/users";
import {INIT_STATE_NAME, InitState} from "./init/init";
import {initReducer} from "./init/init.reducers";
import {InitEffects} from "./init/init.effects";
import {SAVED_REPORTS_STATE_NAME, SavedReportsState} from "./savedReports/savedReports";
import {savedReportsReducer} from "./savedReports/savedReports.reducers";
import {SavedReportsEffects} from "./savedReports/savedReports.effects";
import {DATA_SOURCES_CUSTOM_STATE_NAME, DataSourcesCustomState} from "./dataSourcesCustom/dataSourcesCustom";
import {dataSourcesCustomReducer} from "./dataSourcesCustom/dataSourcesCustom.reducers";
import {DataSourcesCustomEffects} from "./dataSourcesCustom/dataSourcesCustom.effects";
import {DataSourcesOrganicEffects} from "./dataSourcesOrganic/dataSourcesOrganic.effects";
import {DATA_SOURCES_ORGANIC_STATE_NAME, DataSourcesOrganicState} from "./dataSourcesOrganic/dataSourcesOrganic";
import {dataSourcesOrganicReducer} from "./dataSourcesOrganic/dataSourcesOrganic.reducers";
import {DATA_SOURCES_USAGES_STATE_NAME, DataSourcesUsagesState} from "./dataSourcesUsage/dataSourcesUsage";
import {dataSourcesUsageReducer} from "./dataSourcesUsage/dataSourcesUsage.reducers";
import {DataSourcesUsageEffects} from "./dataSourcesUsage/dataSourcesUsage.effects";
import {MATCHINGS_STATE_NAME, MatchingsState} from "./matchings/matchings";
import {matchingsReducer} from "./matchings/matchings.reducers";
import {MatchingsEffects} from "./matchings/matchings.effects";
import {DATA_SOURCES_AD_STATE_NAME, DataSourcesAdState} from "./dataSourcesAd/dataSourcesAd";
import {DATA_SOURCES_SITE_STATE_NAME, DataSourcesSiteState} from "./dataSourcesSite/dataSourcesSite";
import {dataSourcesAdReducer} from "./dataSourcesAd/dataSourcesAd.reducers";
import {dataSourcesSiteReducer} from "./dataSourcesSite/dataSourcesSite.reducers";
import {DataSourcesAdEffects} from "./dataSourcesAd/dataSourcesAd.effects";
import {DataSourcesSiteEffects} from "./dataSourcesSite/dataSourcesSite.effects";
import {EXPORTS_STATE_NAME, ExportsState} from "./exports/exports";
import {exportsReducer} from "./exports/exports.reducers";
import {ExportsEffects} from "./exports/exports.effects";
import {EXPORTS_DESTINATION_STATE_NAME, ExportsDestinationState} from "./exportsDestination/exportsDestination";
import {exportsDestinationReducer} from "./exportsDestination/exportsDestination.reducers";
import {ExportsDestinationEffects} from "./exportsDestination/exportsDestination.effects";
import {LANGUAGES_STATE_NAME, LanguagesState} from "./languages/languages";
import {languagesReducer} from "./languages/languages.reducers";
import {LanguagesEffects} from "./languages/languages.effects";
import {
  NOTIFICATIONS_EXPORTERS_STATE_NAME,
  NotificationsExportersState
} from "./notifications-exporters/notifications-exporters";
import {ALERTS_STATE_NAME, AlertsState} from "./alerts/alerts";
import {alertsReducer} from "./alerts/alerts.reducers";
import {notificationsExportersReducer} from "./notifications-exporters/notifications-exporters.reducers";
import {AlertsEffects} from "./alerts/alerts.effects";
import {NotificationsExportersEffects} from "./notifications-exporters/notifications-exporters.effects";
import {SnackbarEffects} from "./snackbar/snackbar.effects";
import {MatchingEffects} from "./matching/matching.effects";
import {SAVED_REPORTS_FOLDERS_STATE_NAME, SavedReportsFoldersState} from "./savedReportsFolders/savedReportsFolders";
import {savedReportsFoldersReducer} from "./savedReportsFolders/savedReportsFolders.reducers";
import {SavedReportsFoldersEffects} from "./savedReportsFolders/savedReportsFolders.effects";
import {ReportTemplatesState, TEMPLATES_STATE_NAME} from "./templates/templates";
import {templatesReducer} from "./templates/templates.reducers";
import {TemplatesEffects} from "./templates/templates.effects";
import {REPORT_STATE_NAME, ReportState} from "./report/report";
import {reportReducer} from "./report/report.reducers";
import {ReportEffects} from "./report/report.effects";
import {DIALOG_STATE_NAME, DialogState} from "./dialog/dialog";
import {DialogEffects} from "./dialog/dialog.effects";
import {dialogReducer} from "./dialog/dialog.reducers";
import {GENERAL_DIMENSIONS_STATE_NAME, GeneralDimensionsState} from './generalDimensions/generalDimensions';
import {GeneralDimensionsEffects} from './generalDimensions/generalDimensions.effects';
import {DataSetDimensionsEffects} from './dataSetDimensions/dataSetDimensions.effects';
import {DATASET_DIMENSIONS_STATE_NAME, DataSetDimensionsState} from './dataSetDimensions/dataSetDimensions';
import {DataSetDimensionsGroupsEffects} from './dataSetDimensionsGroups/dataSetDimensionsGroups.effects';
import {DATASET_DIMENSIONS_GROUPS_STATE_NAME, DataSetDimensionsGroupsState} from './dataSetDimensionsGroups/dataSetDimensionsGroups';
import {dataSetDimensionsReducer} from './dataSetDimensions/dataSetDimensions.reducers';
import {dataSetDimensionsGroupsReducer} from './dataSetDimensionsGroups/dataSetDimensionsGroups.reducers';
import {generalDimensionsReducer} from './generalDimensions/generalDimensions.reducers';
import {
  DATASET_CONDITIONAL_DIMENSIONS_STATE_NAME,
  DataSetConditionalDimensionsState
} from './dataSetConditionalDimensions/dataSetConditionalDimensions';
import {dataSetConditionalDimensionsReducer} from './dataSetConditionalDimensions/dataSetConditionalDimensions.reducers';
import {DataSetConditionalDimensionsEffects} from './dataSetConditionalDimensions/dataSetConditionalDimensions.effects';
import {DATASET_METRICS_STATE_NAME, DataSetMetricsState} from './dataSetMetrics/dataSetMetrics';
import {dataSetMetricsReducer} from './dataSetMetrics/dataSetMetrics.reducers';
import {DataSetMetricsEffects} from './dataSetMetrics/dataSetMetrics.effects';
import {DATASET_METRICS_GROUPS_STATE_NAME} from './dataSetMetricsGroups/dataSetMetricsGroups';
import {dataSetMetricsGroupsReducer} from './dataSetMetricsGroups/dataSetMetricsGroups.reducers';
import {DataSetMetricsGroupsEffects} from './dataSetMetricsGroups/dataSetMetricsGroups.effects';
import {
  METRICS_CONSENT_AUTO_CORRECTION_STATE_NAME,
  MetricsConsentAutoCorrectionState
} from './metricsConsentAutoCorrection/metricsConsentAutoCorrection';
import {metricsConsentAutoCorrectionReducer} from './metricsConsentAutoCorrection/metricsConsentAutoCorrection.reducers';
import {MetricsConsentAutoCorrectionEffects} from './metricsConsentAutoCorrection/metricsConsentAutoCorrection.effects';
import {PERIODS_STATE_NAME} from './periods/periods';
import {periodsReducer} from './periods/periods.reducers';
import {NOTIFICATIONS_STATE_NAME, NotificationsState} from "./notificationCenter/notificationCenter";
import {notificationCenterReducer} from "./notificationCenter/notificationCenter.reducers";
import {NotificationCenterEffects} from "./notificationCenter/notificationCenter.effects";
import {DATA_SOURCE_PROVIDERS_STATE_NAME, DataSourceProvidersState} from './dataSourceProviders/dataSourceProviders';
import {dataSourceProvidersReducer} from './dataSourceProviders/dataSourceProviders.reducers';
import {DataSourceProvidersEffects} from './dataSourceProviders/dataSourceProviders.effects';

export interface AppState {
  [SITES_STATE_NAME]: SitesState;
  [SPACES_STATE_NAME]: SpacesState;
  [PROFILE_STATE_NAME]: ProfileState;
  [DATA_SOURCE_DIMENSIONS_STATE_NAME]: DataSourceDimensionsState;
  [DATA_SOURCES_METRICS_STATE_NAME]: DataSourcesMetricsState;
  [CHANNELS_STATE_NAME]: ChannelsState;
  [NOTIFICATIONS_STATE_NAME]: NotificationsState;
  [DATA_SOURCES_ALL_STATE_NAME]: DataSourcesAllState;
  [USERS_STATE_NAME]: UsersState;
  [INIT_STATE_NAME]: InitState;
  [SAVED_REPORTS_STATE_NAME]: SavedReportsState;
  [DATA_SOURCES_CUSTOM_STATE_NAME]: DataSourcesCustomState;
  [DATA_SOURCES_ORGANIC_STATE_NAME]: DataSourcesOrganicState;
  [ALERTS_STATE_NAME]: AlertsState;
  [NOTIFICATIONS_EXPORTERS_STATE_NAME]: NotificationsExportersState;
  [DATA_SOURCES_USAGES_STATE_NAME]: DataSourcesUsagesState;
  [MATCHINGS_STATE_NAME]: MatchingsState;
  [DATA_SOURCES_AD_STATE_NAME]: DataSourcesAdState;
  [DATA_SOURCES_SITE_STATE_NAME]: DataSourcesSiteState;
  [EXPORTS_STATE_NAME]: ExportsState;
  [EXPORTS_DESTINATION_STATE_NAME]: ExportsDestinationState;
  [LANGUAGES_STATE_NAME]: LanguagesState;
  [SAVED_REPORTS_FOLDERS_STATE_NAME]: SavedReportsFoldersState;
  [TEMPLATES_STATE_NAME]: ReportTemplatesState;
  [REPORT_STATE_NAME]: ReportState;
  [DIALOG_STATE_NAME]: DialogState;
  [GENERAL_DIMENSIONS_STATE_NAME]: GeneralDimensionsState;
  [DATASET_DIMENSIONS_STATE_NAME]: DataSetDimensionsState;
  [DATASET_DIMENSIONS_GROUPS_STATE_NAME]: DataSetDimensionsGroupsState;
  [DATASET_CONDITIONAL_DIMENSIONS_STATE_NAME]: DataSetConditionalDimensionsState;
  [DATASET_METRICS_STATE_NAME]: DataSetMetricsState;
  [DATASET_METRICS_GROUPS_STATE_NAME]: DataSetDimensionsGroupsState;
  [METRICS_CONSENT_AUTO_CORRECTION_STATE_NAME]: MetricsConsentAutoCorrectionState;
  [DATA_SOURCE_PROVIDERS_STATE_NAME]: DataSourceProvidersState;
}

export const appReducer = {
  [SITES_STATE_NAME]: sitesReducer,
  [SPACES_STATE_NAME]: spacesReducer,
  [PROFILE_STATE_NAME]: profileReducer,
  [DATA_SOURCE_DIMENSIONS_STATE_NAME]: dataSourceDimensionsReducer,
  [DATA_SOURCES_METRICS_STATE_NAME]: dataSourcesMetricsReducer,
  [CHANNELS_STATE_NAME]: channelsReducer,
  [NOTIFICATIONS_STATE_NAME]: notificationCenterReducer,
  [DATA_SOURCES_ALL_STATE_NAME]: dataSourcesAllReducer,
  [USERS_STATE_NAME]: usersReducer,
  [INIT_STATE_NAME]: initReducer,
  [SAVED_REPORTS_STATE_NAME]: savedReportsReducer,
  [DATA_SOURCES_CUSTOM_STATE_NAME]: dataSourcesCustomReducer,
  [DATA_SOURCES_ORGANIC_STATE_NAME]: dataSourcesOrganicReducer,
  [ALERTS_STATE_NAME]: alertsReducer,
  [NOTIFICATIONS_EXPORTERS_STATE_NAME]: notificationsExportersReducer,
  [DATA_SOURCES_ORGANIC_STATE_NAME]: dataSourcesOrganicReducer,
  [DATA_SOURCES_USAGES_STATE_NAME]: dataSourcesUsageReducer,
  [MATCHINGS_STATE_NAME]: matchingsReducer,
  [DATA_SOURCES_AD_STATE_NAME]: dataSourcesAdReducer,
  [DATA_SOURCES_SITE_STATE_NAME]: dataSourcesSiteReducer,
  [EXPORTS_STATE_NAME]: exportsReducer,
  [EXPORTS_DESTINATION_STATE_NAME]: exportsDestinationReducer,
  [LANGUAGES_STATE_NAME]: languagesReducer,
  [SAVED_REPORTS_FOLDERS_STATE_NAME]: savedReportsFoldersReducer,
  [TEMPLATES_STATE_NAME]: templatesReducer,
  [REPORT_STATE_NAME]: reportReducer,
  [DIALOG_STATE_NAME]: dialogReducer,
  [DATASET_DIMENSIONS_STATE_NAME]: dataSetDimensionsReducer,
  [GENERAL_DIMENSIONS_STATE_NAME]: generalDimensionsReducer,
  [DATASET_DIMENSIONS_GROUPS_STATE_NAME]: dataSetDimensionsGroupsReducer,
  [DATASET_CONDITIONAL_DIMENSIONS_STATE_NAME]: dataSetConditionalDimensionsReducer,
  [DATASET_METRICS_STATE_NAME]: dataSetMetricsReducer,
  [DATASET_METRICS_GROUPS_STATE_NAME]: dataSetMetricsGroupsReducer,
  [METRICS_CONSENT_AUTO_CORRECTION_STATE_NAME]: metricsConsentAutoCorrectionReducer,
  [PERIODS_STATE_NAME]: periodsReducer,
  [DATASET_METRICS_GROUPS_STATE_NAME]: dataSetMetricsGroupsReducer,
  [DATA_SOURCE_PROVIDERS_STATE_NAME]: dataSourceProvidersReducer
};

export const appEffects = [
  SitesEffects,
  SpacesEffects,
  ProfileEffects,
  DataSourceDimensionsEffects,
  DataSourcesMetricsEffects,
  ChannelsEffects,
  NotificationCenterEffects,
  DataSourcesAllEffects,
  UsersEffects,
  InitEffects,
  SavedReportsEffects,
  DataSourcesCustomEffects,
  DataSourcesOrganicEffects,
  AlertsEffects,
  NotificationsExportersEffects,
  DataSourcesUsageEffects,
  MatchingsEffects,
  DataSourcesAdEffects,
  DataSourcesSiteEffects,
  ExportsEffects,
  ExportsDestinationEffects,
  LanguagesEffects,
  SnackbarEffects,
  MatchingEffects,
  SavedReportsFoldersEffects,
  TemplatesEffects,
  ReportEffects,
  DataSetDimensionsGroupsEffects,
  GeneralDimensionsEffects,
  DataSetDimensionsEffects,
  DataSetConditionalDimensionsEffects,
  DataSetMetricsEffects,
  DataSetMetricsGroupsEffects,
  DialogEffects,
  MetricsConsentAutoCorrectionEffects,
  DataSourceProvidersEffects
];
